import { Table, TableRow, TableCell, Paragraph, TextRun, WidthType, BorderStyle, AlignmentType, TableLayoutType } from 'docx';
import { BORDER_COLOR } from './constants';
import { formatDate, DEFAULT_CONTENT_WIDTH, equalWidths } from './utils';

export const createTakrirTable = (takrirInfo, contentWidth = DEFAULT_CONTENT_WIDTH) => {
  const cols = equalWidths(contentWidth, 3); // eşit genişlikte üç sütun (sabit twip)
  return new Table({
    width: { size: contentWidth, type: WidthType.DXA },
    layout: TableLayoutType.FIXED,
    columnWidths: cols,
    borders: {
      top: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      bottom: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      left: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      right: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      insideVertical: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            width: { size: cols[0], type: WidthType.DXA },
            children: [new Paragraph({})],
          }),
          new TableCell({
            width: { size: cols[1], type: WidthType.DXA },
            children: [
              new Paragraph({
                children: [new TextRun({
                  text: "YARGITAY 2. CEZA DAİRESİ",
                  bold: true,
                })],
                alignment: AlignmentType.CENTER,
                
              }),
              new Paragraph({
                children: [new TextRun({
                  text: "TAKRİR RAPORU",
                  bold: true,
                })],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
          new TableCell({
            width: { size: cols[2], type: WidthType.DXA },
            children: [new Paragraph({
              children: [new TextRun({
                text: takrirInfo.yargitayEsasNo || '',
                bold: true,
                size: 36,
              })],
              alignment: AlignmentType.RIGHT,
            })],
            margins: {
              left: 100,
              right: 100,
            },
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: { size: cols[0], type: WidthType.DXA },
            children: [new Paragraph({
              children: [new TextRun({
                text: `T. Hâkimi: ${takrirInfo.hakim || ''}`,
              })],
              alignment: AlignmentType.LEFT,
            })],
          }),
          new TableCell({
            width: { size: cols[1], type: WidthType.DXA },
            children: [new Paragraph({})],
          }),
          new TableCell({
            width: { size: cols[2], type: WidthType.DXA },
            children: [new Paragraph({
              children: [new TextRun({
                text: `Takrir Günü: ${formatDate(takrirInfo.takrirGunu) || ''}`,
              })],
              alignment: AlignmentType.RIGHT,
            })],
            margins: {
              left: 100,
              right: 100,
            },
          }),
        ],
      }),
    ],
  });
};

